<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{
       items: [
         {
           title:"Парсинг из групп",
           objName: 'topics_global_search',
           dataType:"topics",
           form: [
             {
               type:'procBinding',
               name: 'Список сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список сообщесв",
                 contentType: 'groups',


               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.groups,
               label: 'Использовать запомненные сообщества: '+ this.$store.state.memory.groups ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               dataType: 'memory',
             },


           {
             type:'textarea',
             name: 'Список сообществ',
             vModel: {name:'itemsList',value:''},
             vkapi: false,
             dataType: 'list'
           },


           {
             type:'select',
             name: 'Порядок вывода тем',
             options: [{text:'По умолчанию',value:''},{text:'по убыванию даты обновления',value:'1'},{text:'по убыванию даты создания',value:'2'},{text:'по возрастанию даты обновления',value:'-1'},{text:'по возрастанию даты создания',value:'-2'} ],
             vModel: {name:'order',value:''},
             vkapi: true
           },
           {
             type: 'input',
             name: 'Колличество с группы',
             vModel: {name:'count',value:'5'},
             vkapi: true
           },
           ],
         },

       ],
     },
    title:{
      first: 'Обсуждений найденно: '
    },

    searchLoop:{
      active:false,
      placeholder:'Названия осуждей'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат поиска обсуждений',
      activator: true,
      activatorName: 'Начать парсинг'
    },


    network:{
      processName: 'topics_global_search',
      dataType: 'topics',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/searcher/topics_global_search.php'
    },



    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'topics',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
      }
     }
   }


       }
     },


   }
</script>


<style>

</style>
